export function getLanguage(state) {
    return state.locale
}

export function getAscending(state) {
    return state.ascending
}

export function getMaxToShow(state) {
    return state.maxOnScreen
}

export function getTimeoutBarVisibility(state) {
    return state.showTimeoutBar
}

export function getRequestCountVisibility(state) {
    return state.showRepeatCount
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/settings/selectors.js